import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_OFFER_MUTATION = gql`
  mutation updateQuote(
    $documentVersion: DocumentVersionInput!,
    $properties: [CustomPropertyInputArbonia] = null,
    $lines: [LineInputType] = null) {
    custom {
      updateQuote(documentId: $documentVersion, properties: $properties, lines: $lines) {
        documentId
        revision
        status
        salesArea {
          id
          name
        }
        snkModifier {
          profile {
            firstName
            lastName
          }
        }
        isTempOffer: customProperty(key: "IsTempConfig") { booleanValue }
        commission: customProperty(key: "Commission") { stringValue }
        ...QuotePricingStateFragment
      }
    }
  }
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOfferMutation extends Mutation<RootMutation> {
  document = UPDATE_OFFER_MUTATION;
}
